export const YEAR = 'year';
export const YEARS = 'years';
export const MONTHS = 'months';
export const WEEKS = 'weeks';
export const DAYS = 'days';
export const HOURS = 'hours';
export const MINUTES = 'minutes';
export const SECONDS = 'seconds';
export const MILLISECONDS = 'milliseconds';
